import script from "./DonorCaseShareIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./DonorCaseShareIcon.vue?vue&type=script&setup=true&lang=js"

import "./DonorCaseShareIcon.vue?vue&type=style&index=0&id=712a6a72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712a6a72"]])

export default __exports__